/**
 * Pushes a Matomo custom event onto the _paq queue.
 * https://matomo.org/faq/how-to/how-do-i-track-an-event-with-matomo/
 *
 * @param {string} category e.g. "Video"
 * @param {string} action e.g. "Play"
 * @param {string} [name] optional event name (this project mostly passes a headline)
 * @param {number} [value] optional numeric value
 */
export function trackEvent(category, action, name, value) {
  if (typeof window === "undefined") return;

  window._paq = window._paq || [];

  const event = ["trackEvent", category, action];
  if (name) event.push(name);
  if (value !== undefined) event.push(value);

  window._paq.push(event);
}

/**
 * Tracks a click on the newsletter signup button in _blocks/newsletterblock.twig.
 * The Mailchimp embed isn't an Alpine component, so this listens on the
 * document instead of binding directly to the button.
 */
export function initNewsletterTracking() {
  document.addEventListener("click", (e) => {
    const button = e.target.closest(
      "#mc-embedded-subscribe-form button[type='submit']",
    );
    if (button) {
      trackEvent("Newsletter", "Signup Click");
    }
  });
}
